const SET_EXTRA = 'directOrderRecurring/SET_EXTRA';
const SET_EXTRAS = 'directOrderRecurring/SET_EXTRAS';

export default {
  // CHANGE_VALUES,

  SET_EXTRA,
  SET_EXTRAS,
};
